import React from 'react';

const TRIAGE_CHIPS = [
  {
    id: 'driver_issue',
    label: 'Driver issue',
    active: ({ triage, participants, delivery }) =>
      (triage.participant_types || []).includes('driver') || Boolean(delivery.driver_name) || Boolean(participants.find(item => item.participant_type === 'driver')),
    className: 'border-orange-200 bg-orange-50 text-orange-800',
  },
  {
    id: 'customer_not_answering',
    label: 'Cliente no contesta',
    active: ({ latestIntent }) => latestIntent === 'customer_not_answering',
    className: 'border-red-200 bg-red-50 text-red-800',
  },
  {
    id: 'identity_unresolved',
    label: 'Identity unresolved',
    active: ({ triage, identity, conversation }) =>
      Boolean(triage.has_unresolved_identity || identity.status === 'unresolved' || conversation?.type === 'unresolved_whatsapp'),
    className: 'border-red-200 bg-red-50 text-red-800',
  },
  {
    id: 'cod_payment',
    label: 'COD/payment',
    active: ({ delivery, recommendedActions }) =>
      delivery.charge != null || delivery.charged != null || recommendedActions.some(action => String(action.type || '').includes('cod')),
    className: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  },
  {
    id: 'needs_human',
    label: 'Needs human',
    active: ({ triage, settings, pendingDraft }) =>
      Boolean(triage.requires_human || settings.is_handoff_required || pendingDraft?.needs_human),
    className: 'border-amber-200 bg-amber-50 text-amber-800',
  },
  {
    id: 'pending_ai_draft',
    label: 'Pending AI draft',
    active: ({ triage, pendingDraft }) => Boolean(triage.has_pending_draft || pendingDraft),
    className: 'border-purple-200 bg-purple-50 text-purple-800',
  },
];

export function AITriageChips({ conversation, triage = {}, settings = {}, identity = {}, participants = [], delivery = {}, pendingDraft, recommendedActions = [] }) {
  const latestIntent = settings.last_intent || pendingDraft?.intent || triage.latest_intent;
  const context = { conversation, triage, settings, identity, participants, delivery, pendingDraft, recommendedActions, latestIntent };

  return (
    <div className="flex flex-wrap gap-1.5">
      {TRIAGE_CHIPS.map(chip => {
        const isActive = chip.active(context);
        return (
          <span
            key={chip.id}
            className={`rounded-full border px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wide ${
              isActive ? chip.className : 'border-slate-200 bg-slate-50 text-slate-400'
            }`}
          >
            {chip.label}
          </span>
        );
      })}
    </div>
  );
}
